import moment from 'moment';

const checkForContentAvailability = contentEnrollment => {
  const availableOn =
    contentEnrollment &&
    contentEnrollment.enrolmentInfo &&
    contentEnrollment.enrolmentInfo.length &&
    contentEnrollment.enrolmentInfo[contentEnrollment.enrolmentInfo.length - 1] &&
    contentEnrollment.enrolmentInfo[contentEnrollment.enrolmentInfo.length - 1].availableOn;
  if (typeof availableOn === 'string') {
    const availableOnDate = availableOn
      ? new Date(availableOn)
          .toString()
          .split('GMT')[0]
          .trim()
      : null;
    return { availableOn: availableOnDate, isAvailable: moment().isAfter(availableOn) };
  }
  return { availableOn, isAvailable: true };
};

export { checkForContentAvailability };
export default checkForContentAvailability;
